import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@icon/calendar-full.svg'
import _imports_1 from '@icon/my-work-checkbox.svg'


const _hoisted_1 = {
  id: "pageHeader",
  class: "header"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "header-left-actions" }, null, -1)
const _hoisted_4 = { class: "header__right header__item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { id: "header-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseHeading = _resolveComponent("BaseHeading")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_icon = _resolveComponent("icon")!
  const _component_HeaderTimesheetMenu = _resolveComponent("HeaderTimesheetMenu")!
  const _component_NotificationList = _resolveComponent("NotificationList")!
  const _component_HeaderMenu = _resolveComponent("HeaderMenu")!
  const _component_HeaderProfileMenu = _resolveComponent("HeaderProfileMenu")!
  const _component_ModalAiSetup = _resolveComponent("ModalAiSetup")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["header__left header__item", { 'learn-tooltip pointer-none': _ctx.selectedStep === _ctx.step }])
    }, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo header__logo"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: 
            require(
              `@/assets/images/${_ctx.isStagingFlag ? 'staging-logo' : 'logo'}${_ctx.isDark ? '-dark' : ''}.svg`
            )
          ,
            alt: ""
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }),
      _createVNode(_component_BaseHeading, {
        level: "2",
        className: "header__title"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.mainHeaderTitle), 1)
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(_component_Breadcrumbs)
    ], 2),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (_ctx.calendarRoute)
        ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _ctx.calendarRoute,
            class: "common-gray-interactive header__icon-link",
            "aria-label": "Calendar",
            tabindex: "-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_icon, {
                class: "img-icon-fill",
                data: _imports_0,
                fill: true,
                width: "var(--icon-24)",
                height: "var(--icon-24)",
                color: "var(--monochrome05to04)"
              })
            ]),
            _: 1
          }, 8, ["to"])), [
            [
              _directive_tooltip,
              { content: 'Calendar', theme: 'info-tooltip' },
              void 0,
              { bottom: true }
            ]
          ])
        : _createCommentVNode("", true),
      (_ctx.timesheetMenuEnabled && _ctx.account?.timesheets)
        ? (_openBlock(), _createBlock(_component_HeaderTimesheetMenu, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(_component_NotificationList),
      (_ctx.account?.urlName)
        ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: {
          name: 'myWork',
          params: { accountId: _ctx.account.urlName }
        },
            class: "common-gray-interactive header__icon-link",
            "aria-label": "My Work",
            tabindex: "-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_icon, {
                class: "img-icon-fill",
                data: _imports_1,
                fill: true,
                width: "var(--icon-24)",
                height: "var(--icon-24)",
                color: "var(--monochrome05to04)"
              })
            ]),
            _: 1
          }, 8, ["to"])), [
            [
              _directive_tooltip,
              { content: 'My Work', theme: 'info-tooltip' },
              void 0,
              { bottom: true }
            ]
          ])
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_component_HeaderMenu, {
        key: _ctx.$route.path
      })),
      _createVNode(_component_HeaderProfileMenu)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_ModalAiSetup)
    ]))
  ]))
}